module.exports = __webpack_public_path__ + "static/media/osvedceniregi.5222ad5d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/osvedceniregi.pdf
// module id = 377
// module chunks = 0